export const acCharger = {
  intro: {
    title: "AC Charger",
    description: `
AC charging is a reliable and space-efficient solution designed for everyday electric vehicle charging needs. It is ideal for residential locations such as homes and apartments, as well as workplaces, hotels, and office parking areas.

AC chargers are easy to install, require minimal infrastructure, and integrate seamlessly into both indoor and outdoor environments.

Designed with safety and efficiency in mind, AC chargers deliver stable power output while protecting the vehicle and electrical system from faults such as over-voltage, over-current, and overheating. With smart connectivity and OCPP support, users can monitor charging sessions remotely, track energy consumption, and manage access with ease.
    `,
    image:
      "/static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png"
  },

  details: {
    title: "AC 7.4 kW EV Charger",
    model: "Aizo Plug 7.4",
    image:
      "/static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png",

    accordionSections: [
      {
        id: "overview",
        title: "Overview",
        content:
          "Compact AC charger suitable for residential and commercial use."
      },
      {
        id: "features",
        title: "Key Features",
        content: "Smart, safe and efficient charging solution.",
        showFeatures: true
      }
    ],

    features: [
      "OCPP 1.6 Compatible",
      "Type-2 Connector",
      "Wall / Pole Mounted",
      "Remote Monitoring"
    ],

    locations: [
      "Home / Apartment",
      "Hotels",
      "Office Parking"
    ]
  }
};


export const dcCharger = {
  intro: {
    title: "DC Charger",
    description: `
DC fast charging delivers high-power direct current to electric vehicles, enabling rapid charging and significantly reducing downtime.

It is ideal for highways, public charging stations, commercial hubs, and fleet operations where fast turnaround times are essential.

Designed for high-performance operation, DC chargers ensure safety, reliability, and smart energy management while supporting modern EV charging standards.
    `,
    image:
      "/static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png"
  },

  details: {
    title: "DC 60 kW EV Fast Charger",
    model: "Aizo Plug DC 60",
    image:
      "/static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png",

    accordionSections: [
      {
        id: "overview",
        title: "Overview",
        content:
          "High-speed DC charger designed for public and commercial charging infrastructure."
      },
      {
        id: "connectors",
        title: "Connector Types",
        content: "Supports CCS2 and CHAdeMO connectors."
      }
    ],

    features: [
      "Fast DC Charging",
      "Remote Diagnostics",
      "Smart Energy Management",
      "Public Charging Ready"
    ]
  }
};
